// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AutoCompleteResults-cls1___f06d31111d90e2e61c3{/*!*/}.AutoCompleteResults-cls2__e7bd3530458cc949051b{display:none;position:absolute;z-index:60;top:48px;left:0px;flex-direction:column;background-color:transparent;width:100%;font-family:\"Roboto\",Helvetica,Arial,sans-serif}.AutoCompleteResults-cls2__e7bd3530458cc949051b.AutoCompleteResults-show___eac33b24471c1bbf95a{display:flex}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "AutoCompleteResults-cls1___f06d31111d90e2e61c3",
	"cls2": "AutoCompleteResults-cls2__e7bd3530458cc949051b AutoCompleteResults-cls1___f06d31111d90e2e61c3",
	"show": "AutoCompleteResults-show___eac33b24471c1bbf95a"
};
export default ___CSS_LOADER_EXPORT___;
